import {
  GET_TRANSFERS,
  GET_TRANSFERS_SUCCESS,
  GET_TRANSFERS_FAIL,
  GET_STATUS_TRANSFERS,
  GET_STATUS_TRANSFERS_SUCCESS,
  GET_STATUS_TRANSFERS_FAIL,
  GET_COMPLETED_TRANSFERS,
  GET_COMPLETED_TRANSFERS_SUCCESS,
  GET_COMPLETED_TRANSFERS_FAIL,
  GET_FILTERED_TRANSFERS_MOSCOW,
  GET_FILTERED_TRANSFERS_MOSCOW_SUCCESS,
  GET_FILTERED_TRANSFERS_MOSCOW_FAIL,
  ADD_TRANSFER,
  ADD_TRANSFER_SUCCESS,
  ADD_TRANSFER_FAIL,
  UPDATE_TRANSFER,
  UPDATE_TRANSFER_SUCCESS,
  UPDATE_TRANSFER_FAIL,
  DELETE_TRANSFER,
  DELETE_TRANSFER_SUCCESS,
  DELETE_TRANSFER_FAIL,
  GET_TRANSFERS_MOSCOW,
  GET_TRANSFERS_MOSCOW_SUCCESS,
  GET_TRANSFERS_MOSCOW_FAIL,
  GET_TRANSFERS_MOSCOW_LIST,
  GET_TRANSFERS_MOSCOW_LIST_SUCCESS,
  GET_TRANSFERS_MOSCOW_LIST_FAIL,
  ADD_TRANSFER_MOSCOW,
  ADD_TRANSFER_MOSCOW_SUCCESS,
  ADD_TRANSFER_MOSCOW_FAIL,
  UPDATE_TRANSFER_MOSCOW,
  UPDATE_TRANSFER_MOSCOW_SUCCESS,
  UPDATE_TRANSFER_MOSCOW_FAIL,
  DELETE_TRANSFER_MOSCOW,
  DELETE_TRANSFER_MOSCOW_SUCCESS,
  DELETE_TRANSFER_MOSCOW_FAIL,
  GET_TRANSFERS_PRIORITY,
  GET_TRANSFERS_PRIORITY_SUCCESS,
  GET_TRANSFERS_PRIORITY_FAIL,
  ADD_TRANSFER_PRIORITY,
  ADD_TRANSFER_PRIORITY_SUCCESS,
  ADD_TRANSFER_PRIORITY_FAIL,
  UPDATE_TRANSFER_MOSCOW_DATA,
  UPDATE_TRANSFER_MOSCOW_DATA_SUCCESS,
  UPDATE_TRANSFER_MOSCOW_DATA_FAIL,
  UPDATE_TRANSFER_PRIORITY,
  UPDATE_TRANSFER_PRIORITY_SUCCESS,
  UPDATE_TRANSFER_PRIORITY_FAIL,
  DELETE_TRANSFER_PRIORITY,
  DELETE_TRANSFER_PRIORITY_SUCCESS,
  DELETE_TRANSFER_PRIORITY_FAIL,
  DELETE_TRANSFER_SHIPPING,
  DELETE_TRANSFER_SHIPPING_SUCCESS,
  DELETE_TRANSFER_SHIPPING_FAIL,
  GET_TRANSFERS_SHIPPING,
  GET_TRANSFERS_SHIPPING_SUCCESS,
  GET_TRANSFERS_SHIPPING_FAIL,
  GET_AGENTS,
  GET_AGENTS_SUCCESS,
  GET_AGENTS_FAIL,
  ADD_AGENT,
  ADD_AGENT_SUCCESS,
  ADD_AGENT_FAIL,
  UPDATE_AGENT,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_FAIL,
  DELETE_AGENT,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET ALL TRANSFERS
export const getTransfers = () => ({
  type: GET_TRANSFERS
});
export const getTransfersSuccess = (transfers) => ({
  type: GET_TRANSFERS_SUCCESS,
  payload: transfers
});
export const getTransfersFail = (error) => ({
  type: GET_TRANSFERS_FAIL,
  payload: error
});
// GET ALL TRANSFERS WITH SELECTED STATUS
export const getStatusTransfers = (transfers) => ({
  type: GET_STATUS_TRANSFERS,
  payload: transfers
});
export const getStatusTransfersSuccess = (transfers) => ({
  type: GET_STATUS_TRANSFERS_SUCCESS,
  payload: transfers
});
export const getStatusTransfersFail = (error) => ({
  type: GET_STATUS_TRANSFERS_FAIL,
  payload: error
});
// GET ALL TRANSFERS SHIPPING WITH COMPETED STATUS
export const getCompletedTransfers = (transfers_completed) => ({
  type: GET_COMPLETED_TRANSFERS,
  payload: transfers_completed
});
export const getCompletedTransfersSuccess = (transfers_completed) => ({
  type: GET_COMPLETED_TRANSFERS_SUCCESS,
  payload: transfers_completed
});
export const getCompletedTransfersFail = (error) => ({
  type: GET_COMPLETED_TRANSFERS_FAIL,
  payload: error
});

// GET ALL TRANSFERS MOSCOW FILTERED DATA
export const getFilteredTransfersMoscow = (transfers_moscow_filtered) => ({
  type: GET_FILTERED_TRANSFERS_MOSCOW,
  payload: transfers_moscow_filtered
});
export const getFilteredTransfersMoscowSuccess = (transfers_moscow_filtered) => ({
  type: GET_FILTERED_TRANSFERS_MOSCOW_SUCCESS,
  payload: transfers_moscow_filtered
});
export const getFilteredTransfersMoscowFail = (error) => ({
  type: GET_FILTERED_TRANSFERS_MOSCOW_FAIL,
  payload: error
});
// ADD NEW TRANSFER
export const addTransfer = (transfer) => ({
  type: ADD_TRANSFER,
  payload: transfer
});
export const addTransferSuccess = (transfer) => ({
  type: ADD_TRANSFER_SUCCESS,
  payload: transfer
});
export const addTransferFail = (error) => ({
  type: ADD_TRANSFER_FAIL,
  payload: error
});
// UPDATE TRANSFER
export const updateTransfer = (transfer) => ({
  type: UPDATE_TRANSFER,
  payload: transfer
});
export const updateTransferSuccess = (transfer) => ({
  type: UPDATE_TRANSFER_SUCCESS,
  payload: transfer
});
export const updateTransferFail = (error) => ({
  type: UPDATE_TRANSFER_FAIL,
  payload: error
});
// DELETE TRANSFER
export const deleteTransfer = (transfer) => ({
  type: DELETE_TRANSFER,
  payload: transfer
});
export const deleteTransferSuccess = (transfer) => ({
  type: DELETE_TRANSFER_SUCCESS,
  payload: transfer
});
export const deleteTransferFail = (error) => ({
  type: DELETE_TRANSFER_FAIL,
  payload: error
});

// GET ALL TRANSFERS MOSCOW
export const getTransfersMoscow = () => ({
  type: GET_TRANSFERS_MOSCOW
});
export const getTransfersMoscowSuccess = (transfers_moscow) => ({
  type: GET_TRANSFERS_MOSCOW_SUCCESS,
  payload: transfers_moscow
});
export const getTransfersMoscowFail = (error) => ({
  type: GET_TRANSFERS_MOSCOW_FAIL,
  payload: error
});

export const getTransfersMoscowList = () => ({
  type: GET_TRANSFERS_MOSCOW_LIST
});
export const getTransfersMoscowListSuccess = (transfers_moscow_list) => ({
  type: GET_TRANSFERS_MOSCOW_LIST_SUCCESS,
  payload: transfers_moscow_list
});
export const getTransfersMoscowListFail = (error) => ({
  type: GET_TRANSFERS_MOSCOW_LIST_FAIL,
  payload: error
});

// ADD NEW TRANSFER
export const addTransferMoscow = (transfers_moscow) => ({
  type: ADD_TRANSFER_MOSCOW,
  payload: transfers_moscow
});
export const addTransferMoscowSuccess = (transfers_moscow) => ({
  type: ADD_TRANSFER_MOSCOW_SUCCESS,
  payload: transfers_moscow
});
export const addTransferMoscowFail = (error) => ({
  type: ADD_TRANSFER_MOSCOW_FAIL,
  payload: error
});
// UPDATE TRANSFER
export const updateTransferMoscow = (transfers_moscow) => ({
  type: UPDATE_TRANSFER_MOSCOW,
  payload: transfers_moscow
});
export const updateTransferMoscowSuccess = (transfers_moscow) => ({
  type: UPDATE_TRANSFER_MOSCOW_SUCCESS,
  payload: transfers_moscow
});
export const updateTransferMoscowFail = (error) => ({
  type: UPDATE_TRANSFER_MOSCOW_FAIL,
  payload: error
});
// DELETE TRANSFER
export const deleteTransferMoscow = (transfers_moscow) => ({
  type: DELETE_TRANSFER_MOSCOW,
  payload: transfers_moscow
});
export const deleteTransferMoscowSuccess = (transfers_moscow) => ({
  type: DELETE_TRANSFER_MOSCOW_SUCCESS,
  payload: transfers_moscow
});
export const deleteTransferMoscowFail = (error) => ({
  type: DELETE_TRANSFER_MOSCOW_FAIL,
  payload: error
});

// GET ALL TRANSFERS PRIORITY
export const getTransfersPriority = () => ({
  type: GET_TRANSFERS_PRIORITY
});
export const getTransfersPrioritySuccess = (transfers_priority) => ({
  type: GET_TRANSFERS_PRIORITY_SUCCESS,
  payload: transfers_priority
});
export const getTransfersPriorityFail = (error) => ({
  type: GET_TRANSFERS_PRIORITY_FAIL,
  payload: error
});
// ADD NEW TRANSFER
export const addTransferPriority = (transfers_priority) => ({
  type: ADD_TRANSFER_PRIORITY,
  payload: transfers_priority
});
export const addTransferPrioritySuccess = (transfers_priority) => ({
  type: ADD_TRANSFER_PRIORITY_SUCCESS,
  payload: transfers_priority
});
export const addTransferPriorityFail = (error) => ({
  type: ADD_TRANSFER_PRIORITY_FAIL,
  payload: error
});
// UPDATE TRANSFER
export const updateTransferPriority = (transfers_priority) => ({
  type: UPDATE_TRANSFER_PRIORITY,
  payload: transfers_priority
});
export const updateTransferPrioritySuccess = (transfers_priority) => ({
  type: UPDATE_TRANSFER_PRIORITY_SUCCESS,
  payload: transfers_priority
});
export const updateTransferPriorityFail = (error) => ({
  type: UPDATE_TRANSFER_PRIORITY_FAIL,
  payload: error
});
// DELETE TRANSFER
export const deleteTransferPriority = (transfers_priority) => ({
  type: DELETE_TRANSFER_PRIORITY,
  payload: transfers_priority
});
export const deleteTransferPrioritySuccess = (transfers_priority) => ({
  type: DELETE_TRANSFER_PRIORITY_SUCCESS,
  payload: transfers_priority
});
export const deleteTransferPriorityFail = (error) => ({
  type: DELETE_TRANSFER_PRIORITY_FAIL,
  payload: error
});

export const getTransfersShipping = () => ({
  type: GET_TRANSFERS_SHIPPING
});
export const getTransfersShippingSuccess = (transfers_shipping) => ({
  type: GET_TRANSFERS_SHIPPING_SUCCESS,
  payload: transfers_shipping
});
export const getTransfersShippingFail = (error) => ({
  type: GET_TRANSFERS_SHIPPING_FAIL,
  payload: error
});

export const updateTransferMoscowData = (transfers_moscow_data) => ({
  type: UPDATE_TRANSFER_MOSCOW_DATA,
  payload: transfers_moscow_data
});
export const updateTransferMoscowDataSuccess = (transfers_moscow_data) => ({
  type: UPDATE_TRANSFER_MOSCOW_DATA_SUCCESS,
  payload: transfers_moscow_data
});
export const updateTransferMoscowDataFail = (error) => ({
  type: UPDATE_TRANSFER_MOSCOW_DATA_FAIL,
  payload: error
});

export const deleteTransferShipping = (transfers_shipping) => ({
  type: DELETE_TRANSFER_SHIPPING,
  payload: transfers_shipping
});
export const deleteTransferShippingSuccess = (transfers_shipping) => ({
  type: DELETE_TRANSFER_SHIPPING_SUCCESS,
  payload: transfers_shipping
});
export const deleteTransferShippingFail = (error) => ({
  type: DELETE_TRANSFER_SHIPPING_FAIL,
  payload: error
});

// GET ALL AGENTS
export const getAgents = () => ({
  type: GET_AGENTS
});
export const getAgentsSuccess = (agents) => ({
  type: GET_AGENTS_SUCCESS,
  payload: agents
});
export const getAgentsFail = (error) => ({
  type: GET_AGENTS_FAIL,
  payload: error
});
// ADD NEW AGENT
export const addAgent = (agent) => ({
  type: ADD_AGENT,
  payload: agent
});
export const addAgentSuccess = (transfer) => ({
  type: ADD_AGENT_SUCCESS,
  payload: transfer
});
export const addAgentFail = (error) => ({
  type: ADD_AGENT_FAIL,
  payload: error
});
// UPDATE AGENT
export const updateAgent = (agent) => ({
  type: UPDATE_AGENT,
  payload: agent
});
export const updateAgentSuccess = (agent) => ({
  type: UPDATE_AGENT_SUCCESS,
  payload: agent
});
export const updateAgentFail = (error) => ({
  type: UPDATE_AGENT_FAIL,
  payload: error
});
// DELETE AGENT
export const deleteAgent = (agent) => ({
  type: DELETE_AGENT,
  payload: agent
});
export const deleteAgentSuccess = (agent) => ({
  type: DELETE_AGENT_SUCCESS,
  payload: agent
});
export const deleteAgentFail = (error) => ({
  type: DELETE_AGENT_FAIL,
  payload: error
});

// DISPLAY LOADING ICON
export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});
export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});
